import {SelectDataProps} from 'shared/types/select-data';

export enum Operators {
  Contains = 'contains',
  NotEqual = 'notIn',
  Equals = 'equals',
  GreaterThanEqual = 'gte',
  LessThanEqual = 'lte',
}

export interface DateFilterProps {
  date: string;
  time: string;
}

export type FilterValueProps =
  | string
  | number
  | boolean
  | string[]
  | DateFilterProps[];

export interface FilterProps {
  field: SelectDataProps;
  operator: Operators;
  value: FilterValueProps;
}

export type FilterTypeEnum = 'select' | 'multi-select' | 'text' | 'date';

export interface FilterOptionProps {
  field: string;
  label: string;
  values?: SelectDataProps[];
  centerValue?: boolean;
  type: FilterTypeEnum;
  valueAsNumber?: boolean;
  search?: boolean;
  dateInterval?: boolean;
}
